import { UserInfoType } from '../type/UserInfoType';
import { HandlerOutputType } from '../type/HandlerType';
import { queryGetSessionInfo } from '../api/queryGetSessionInfo';
import { determinePermission } from '../utils/determinePermission';
import { dialog, unknownLabel } from '../const/commonConst';

/**
 * セッション情報を取得し、権限を判定する関数
 */
export const getSessionInfoHandler = async (authorizationToken: string): Promise<HandlerOutputType<UserInfoType>> => {
	try {
		// セッション情報を取得する
		const [isGetError, getSessionInfoResult] = await queryGetSessionInfo(authorizationToken);
		console.log(getSessionInfoResult);

		if (isGetError || !getSessionInfoResult || !getSessionInfoResult.getCoexistenceUISessionInfo) {
			return [dialog.systemError, undefined];
		}

		// 共通ウェブポータルサービスの権限を判定
		const [isDetermineError, permissionNum] = determinePermission(
			getSessionInfoResult.getCoexistenceUISessionInfo.offsegPermissionName,
			getSessionInfoResult.getCoexistenceUISessionInfo.g500LiteAuthority,
		);

		// エラーチェック
		if (isDetermineError) {
			return [dialog.systemError, undefined];
		}

		const sessionInfo: UserInfoType = {
			isLogin: true,
			companyName: getSessionInfoResult.getCoexistenceUISessionInfo.offsegCompanyName || unknownLabel,
			userName: getSessionInfoResult.getCoexistenceUISessionInfo.offsegUserName || unknownLabel,
			permission: permissionNum,
		};

		return [dialog.success, sessionInfo];
	} catch (err: unknown) {
		console.error(err);

		return [dialog.systemError, undefined];
	}
};
